import { useApiMutation } from "../../useApiMutation";

export interface AddPointsMovementPayload {
    accountId: number | string;
    moveDate: string;
    value: number;
    cause: string;
    media: string;
}

const useAddPointsMovement = () => {
    const { mutate: addPointsMovement, isLoading, error, success, reset } = useApiMutation<AddPointsMovementPayload>(
        "/batch_per_account_misc_moves",
        { headers: { "Content-Type": "application/ld+json" } }
    );

    return { addPointsMovement, isLoading, error, success, reset };
};

export default useAddPointsMovement;
